module.exports = __webpack_public_path__ + "img/residentList1.c53746d2.png";